import React from "react";

import { AvatarProps, useTheme } from "@mui/material";

import { IgDot } from "./IgDot";

interface StatusCircleProps extends Omit<AvatarProps, "children"> {
  color?: "primary" | "secondary" | "error" | "warning" | "info" | "success";
}

export const IgStatusCircle: React.FC<StatusCircleProps> = (props) => {
  const { color = "primary", sx } = props;
  const theme = useTheme();

  const statusColorMap = {
    primary: theme.palette.primary.main,
    secondary: theme.igPrimitives.gray.A200,
    error: theme.igIconColors.error,
    warning: theme.igIconColors.warning,
    info: theme.igIconColors.info,
    success: theme.igIconColors.success,
  };

  return <IgDot color={statusColorMap[color]} sx={sx} />;
};
